/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { jsx, css } from '@emotion/react'
import ReactCountryFlag from "react-country-flag"
import { Trans, Translation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Separator } from './layout/Separator'
import { globalSettingsList } from '../actions/settings'
import { useTranslation } from 'react-i18next'

export const FaxVerificationExpiredMessage = ({ ...props }) => {

    const { t } = useTranslation();
    
    return (
        <div>
          <Trans>
            The fax you sent from your email earlier has now expired. Please send the fax again.
          </Trans>
          <Separator variant="h10" />

          <Trans i18nKey="faxverificationexpiredmessage_after_you_sent_your_email">
            After you sent your email to fax you have 15 minutes to click the confirmation link in the verification reply-email you receive from XOIP. After that time XOIP will immediately and securely delete your file from the XOIP servers, so that potentially private information in the file will not be stored for longer than necessary.
          </Trans>
          <Separator variant="h10" />

          <Trans i18nKey="faxverificationexpiredmessage_to_change_your_security_options"
                 components={[<Link to="/send_a_fax"/>]}
                 defaults="To change your security options, for example to send faxes without requiring this confirmation, <0>login</0>, and open 'More options' under 'Email to fax'" 
          />
          
        </div>
    )

}
